import React from "react";
import Banner from "../signup/Banner";
import colors from "../../../utils/colors";
import LoginForm from "./LoginForm";
import { useNavigate } from "react-router-dom";
import { forerunnerIcon2, leftArrIcon } from "../../../assets";
import { Flex, Image, useMediaQuery } from "@chakra-ui/react";

const Login = () => {
  const navigate = useNavigate();
  const [isMobile] = useMediaQuery("(max-width: 767px)");

  return (
    <>
      {isMobile && (
        <Flex justifyContent={"center"}>
          <Image src={forerunnerIcon2} boxSize={"48px"} mt={"20px"} />
        </Flex>
      )}
      <div className="flex">
        {!isMobile && <Banner />}
        <div className="flex flex-col flex-1 gap-[24px] md:gap-[40px] p-[5%] md:p-[10%]">
          <div
            className="flex flex-col w-full gap-[10px] md:gap-[20px]"
            style={{ color: colors.dark }}
          >
            <div className="font-lexend text-[20px] md:text-[32px] font-[600] leading-normal">
              {"Log in"}
            </div>
            <div className="font-lato text-[14px] md:text-[20px] font-[400]">
              {`Welcome back!`}
            </div>
          </div>
          <LoginForm />
          <p className="font-lato font-[400] mt-[-20px] text-[14px] md:text-[18px] leading-[21.6px]">
            Don't have an account?{" "}
            <span
              className="cursor-pointer font-[700]"
              style={{ color: colors.primary }}
              onClick={() => navigate("/signup")}
            >
              Sign up
            </span>
          </p>
        </div>
      </div>
    </>
  );
};

export default Login;
